import { React } from 'Imports';
import { isEncompass } from '$Utilities/integrationPlatform';
import classNames from 'classnames';

const styles = require('./BulkActionsBar.scss') as {
    bulkActionsContainer: string;
    bulkActionsContainerGeotab: string;
    bulkActionsContainerEncompass: string;
    bulkActionCancelButtonGeotab: string;
    bulkActionCancelButtonEncompass: string;
    bulkActionButtonGroupGeotab: string;
    bulkActionButtonGroupEncompass: string;
};

interface IBulkActionsBarProps {
    slots?: {
        left?: React.ReactNode;
        right?: React.ReactNode;
    };
}

export const BulkActionsBar = (props: IBulkActionsBarProps) => {
    if (props.slots) {
        return (
            <div
                className={classNames(
                    styles.bulkActionsContainer,
                    isEncompass ? styles.bulkActionsContainerEncompass : styles.bulkActionsContainerGeotab,
                )}
            >
                {props.slots?.left ? (
                    <div className={isEncompass ? styles.bulkActionCancelButtonEncompass : styles.bulkActionCancelButtonGeotab}>
                        {props.slots.left}
                    </div>
                ) : (
                    <></>
                )}
                {props.slots?.right ? (
                    <div className={isEncompass ? styles.bulkActionButtonGroupEncompass : styles.bulkActionButtonGroupGeotab}>
                        {props.slots.right}
                    </div>
                ) : (
                    <></>
                )}
            </div>
        );
    }
};
